export function getResetPasswordParams(search) {
  const { searchParams } = new URL(search);

  return {
    email: searchParams.get('email'),
    idHash: searchParams.get('idHash'),
    token: searchParams.get('token'),
  };
}
